import { AmountSuperScript } from "components/design/AmountSuperScript";
import { RadioCard } from "components/RadioCard/RadioCard";
import { USD } from "constants/currency";
import { WRITE_OFF_REMAINING } from "constants/invoiceResolveOptions";
import { pluralize } from "utils/pluralize";
import { WriteOffDateField } from "./WriteOffDateField";

type WriteOffRemainingOptionProps = {
  amount: number;
  isSelected: boolean;
  invoiceDate?: string | null;
  invoiceCount?: number;
};

export const WriteOffRemainingOption = ({
  amount,
  isSelected,
  invoiceDate,
  invoiceCount = 1,
}: WriteOffRemainingOptionProps) => (
  <>
    <RadioCard value={WRITE_OFF_REMAINING}>
      <div className="t-text-body-sm t-flex t-flex-col t-gap-0.5">
        <span>Write off pending amount</span>
        <p className="t-text-text-30 t-m-0 t-italic t-text-body-italic sm:t-text-body-sm-italic">
          Marks the {pluralize(invoiceCount, "invoice", "invoices", false)} Paid
          and writes off the remaining{" "}
          <AmountSuperScript amount={amount} currencyCode={USD} /> to Bad Debt.
        </p>
      </div>
    </RadioCard>
    {isSelected && (
      <div className="t-border-solid t-border-neutral-10 t-border t-p-3 t-rounded-md">
        <WriteOffDateField
          name="write_off_date"
          amount={amount}
          invoiceDate={invoiceDate}
        />
      </div>
    )}
  </>
);
